var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6161 8.94469C21.6901 7.87075 21.6901 6.12955 20.6161 5.05561L19.2019 3.64139C18.128 2.56745 16.3868 2.56745 15.3128 3.64139L4.21717 14.737C3.76057 15.1936 3.4792 15.7964 3.42238 16.4396L3.1803 19.18C3.08445 20.265 3.99248 21.1731 5.0775 21.0772L7.81792 20.8351C8.46115 20.7783 9.06387 20.497 9.52047 20.0403L20.6161 8.94469ZM19.5555 6.11627C20.0436 6.60442 20.0436 7.39588 19.5555 7.88403L18.6058 8.8337L15.4238 5.65172L16.3735 4.70205C16.8616 4.2139 17.6531 4.2139 18.1412 4.70205L19.5555 6.11627ZM14.3632 6.71238L17.5451 9.89436L8.45981 18.9797C8.25226 19.1872 7.9783 19.3151 7.68592 19.341L4.94551 19.583C4.7905 19.5967 4.66078 19.467 4.67448 19.312L4.91656 16.5716C4.94239 16.2792 5.07028 16.0053 5.27783 15.7977L14.3632 6.71238Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpencil);
export default __webpack_public_path__ + "static/media/editpencil.9f88ad96c36294d33153be7f673a3c40.svg";
export { ForwardRef as ReactComponent };